module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('general-item', {
    attrs: {
      "format": "component"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.in_one_component')))]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.one_component_to_integrate')))])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-2ee859b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/types/items/Component.vue
 ** module id = 791
 ** module chunks = 1
 **/